import { render, staticRenderFns } from "./RoutineExtentCard.vue?vue&type=template&id=861cbc1c&scoped=true"
import script from "./RoutineExtentCard.vue?vue&type=script&lang=js"
export * from "./RoutineExtentCard.vue?vue&type=script&lang=js"
import style0 from "./RoutineExtentCard.vue?vue&type=style&index=0&id=861cbc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861cbc1c",
  null
  
)

export default component.exports